import loadable from "@loadable/component";
import Protected from "../pages/Protected";

const CreateForm = loadable(() => import('../pages/PushNotification/Form'))

const PushNotificationRoutes = [
    { path: '/push-notify/create', element: <Protected page={true} permission="create-post"><CreateForm /></Protected> },
]

export default PushNotificationRoutes